<template>
  <div class="footer">
    <div class="contact-us" id="about">
      <div class="title">
        <div class="title-top">联系我们</div>
      </div>
      <div class="footer-main">
        <p class="left text-ellipsis">
          {{contactText}}
        </p>
      </div>
      <div class="right">
        <div class="pic-box" v-if="contactPic.pc">
          <img :src="contactPic.pc.img">
          <p class="text-ellipsis">{{contactPic.pc.value}}</p>
        </div>
        <div class="pic-box" v-if="contactPic.h5">
          <img :src="contactPic.h5.img">
          <p class="text-ellipsis">{{contactPic.h5.value}}</p>
        </div>
      </div>
    </div>
    <div class="copyright">
      <p class="left">
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="noopener noreferrer">
          {{homeInfo.icpInfo}}
        </a>
        |
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="noopener noreferrer">
          {{homeInfo.webRecord}}
        </a>
        <br />
        "<a herf="javascrip;" class="huodongxing" style="cursor: pointer;">{{$t('message.company')}}</a>"{{$t('message.technology')}}
      </p>
      <!-- <p class="right">
        <img :src="homeInfo.webLogoFooter" width="197px" />
        <a href="/">{{$t('message.PrivacyOverviewTitle')}}</a>
        <a href="/">{{$t('message.terms')}}</a>
      </p> -->
    </div>
    <div class="backtop">
      <el-backtop :right="0" :bottom="160"></el-backtop>
    </div>
    <!-- <el-dialog
      append-to-body
      :title="$t('message.PrivacyOverviewTitle')"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <p style="color: #626262" v-html="$i18n.locale == 'zh-CN'?introduction:introductionEn">
        {{$t('message.PrivacyOverview')}}
      </p>
    </el-dialog> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      eid: this.$route.query.eid || '', //会议id
      // dialogVisible: false,
      contactText: '',
      contactPic: {}
    };
  },
  computed: {
    ...mapGetters({
      homeInfo: 'homeInfo'
    })
  },
  created() {
    this.$callApi(this.$apiList.aboutUs, { eid: this.eid }).then(res => {
      const data = res.data
      this.contactText = data.aboutContent
      this.contactPic = JSON.parse(data.aboutPicture)
    })
  }
};
</script>
<style lang="less">
  .backtop {
    position: fixed;
    bottom: 0;
    width: 1080px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 3;
    .el-backtop {
      height: 80px;
      width: 80px;
      position: absolute;
      background-color: #2e2294;
      border: 1px solid #2e2294;
      color: #fff;
      .el-icon-caret-top:before {
        content: '\e6e1';
        font-size: 40px;
      }
    }
  }
</style>
<style lang="less" scoped>
  @import '@/style/variable.less';
  .footer {
    padding-top: 40px;
    min-width: 1080px;
    background-color: #00002d;

    .contact-us {
      width: 1080px;
      margin: 0 auto;

      .title {
        margin-bottom: 20px;
        font-size: 30px;
        line-height: 35px;
        font-weight: 500;
        color: #fff;
        background-image: url(https://cdn.huodongxing.com/web-meeting/img/contact-title.png);
        background-repeat: no-repeat;
        background-size: auto 24px;
        background-position: 16px top;

        .title-top {
          padding: 16px 0 0 16px;
          font-size: 32px;
          line-height: 32px;
        }

        &::before {
          content: '';
          float: left;
          width: 2px;
          height: 48px;
          background: #ffffff;
          opacity: 0.8;
        }
      }

      .footer-main {
        width: 1080px;
        display: flex;

        .left {
          flex-grow: 1;
          display: inline-block;
          padding: 20px 0;
          white-space: pre-line;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 40px;
        }
      }

      .right {
        display: inline-block;
        margin-top: 40px;

        .pic-box {
          display: inline-block;

          &:first-child {
            margin-right: 80px;
          }

          img {
            width: 200px;
            height: 200px;
            margin-bottom: 20px;
          }

          p {
            width: 100%;
            text-align: center;
            font-size: 14px;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }

    .copyright {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 108px;
      width: 1080px;
      margin: 20px auto 0;

      .left {
        line-height: 24px;
        color: #b0afaf;

        a {
          color: #b0afaf;
        }

        .huodongxing {
          color: #1abc51;
        }
      }

      .right {
        img {
          display: inline-block;
        }
        a {
          display: inline-block;
          margin-left: 20px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 20px;
          text-decoration: underline;
        }
      }
    }
  }
</style>
